// Sign-up options, paying for the plan later, store modes and plan text (round 15).
export default {
  // Store modes
  "Online + in my shop": "أونلاين + في محلي",
  "A website with delivery and pickup, plus the POS for counter sales.": "موقع مع التوصيل والاستلام، ونظام نقاط البيع للبيع في المحل.",
  "Online store only": "متجر إلكتروني فقط",
  "Sell on your website with delivery and pickup.": "بِع من موقعك مع التوصيل والاستلام.",
  "Shop with POS": "محل مع نقاط البيع (POS)",
  "Sell at the counter with the POS. Your website shows your products and customers order to collect.": "بِع عند الكاشير بنظام نقاط البيع. يعرض موقعك منتجاتك ويطلب العملاء للاستلام من المحل.",
  "How do you sell?": "كيف تبيع؟",

  // Countries
  "Jordan": "الأردن",
  "Iraq": "العراق",
  "Egypt": "مصر",
  "Morocco": "المغرب",

  // Sign-up
  "Store": "المتجر",
  "Pick the plan that fits your business. You can change it any time.": "اختر الباقة المناسبة لنشاطك. يمكنك تغييرها في أي وقت.",
  "No payment today. Create your store first, then pay for your plan from your dashboard.": "لا دفع اليوم. أنشئ متجرك أولًا، ثم ادفع باقتك من لوحة التحكم.",
  "Pay later from your dashboard": "ادفع لاحقًا من لوحة التحكم",
  "Sets your prices' currency and your time zone.": "تحدد عملة أسعارك ومنطقتك الزمنية.",
  "Main language": "اللغة الرئيسية",
  "Customers can still switch language on your website.": "يستطيع العملاء تغيير اللغة في موقعك.",
  "Your summary": "ملخص طلبك",
  "To pay today": "المطلوب دفعه اليوم",
  "You'll pay for your plan from your dashboard after your store is created.": "ستدفع باقتك من لوحة التحكم بعد إنشاء متجرك.",
  "Plans are temporarily unavailable": "الباقات غير متاحة مؤقتًا",
  "No active production plans were returned. Please try again in a moment.": "لم تصل أي باقات مفعّلة من خادم الإنتاج. يرجى المحاولة بعد قليل.",
  "Reload plans": "إعادة تحميل الباقات",
  "Do you also want reservations on your online store?": "هل تريد إضافة الحجوزات إلى متجرك الإلكتروني؟",
  "Customers can shop and reserve appointments, tables, rooms or services from the same website.": "يمكن لعملائك التسوق وحجز المواعيد أو الطاولات أو الغرف أو الخدمات من الموقع نفسه.",
  "Add reservations to the online store?": "إضافة الحجوزات إلى المتجر الإلكتروني؟",
  "Yes, add reservations": "نعم، أضف الحجوزات",
  "No, products only": "لا، المنتجات فقط",
  "Your phone number is required": "رقم هاتفك مطلوب",
  "We use it as the main contact for your business and show it to customers on your website and receipts.": "نستخدمه كوسيلة التواصل الرئيسية لنشاطك، ويظهر للعملاء في موقعك وفواتيرك.",
  "Phone number (required)": "رقم الهاتف (مطلوب)",
  "Optional. You can change it later in Settings.": "اختياري. يمكنك تغييره لاحقًا من الإعدادات.",
  "Required for your business account, customer contact and receipts.": "مطلوب لحساب نشاطك وتواصل العملاء والفواتير.",
  "We couldn't check this address. Try again.": "تعذّر التحقق من هذا العنوان. حاول مرة أخرى.",
  "The address format is valid. Final availability will be confirmed when you create the store.": "صيغة العنوان صحيحة. سيتم تأكيد توفره نهائيًا عند إنشاء المتجر.",
  "Confirm password": "تأكيد كلمة المرور",
  "Enter the password again": "أدخل كلمة المرور مرة أخرى",
  "Confirm the new password": "أكّد كلمة المرور الجديدة",
  "Passwords do not match": "كلمتا المرور غير متطابقتين",
  "The server took too long to respond. Please try again.": "استغرق الخادم وقتًا طويلًا في الاستجابة. حاول مرة أخرى.",
  "Could not reach the server. Check your connection and try again.": "تعذّر الاتصال بالخادم. تحقّق من اتصالك وحاول مرة أخرى.",
  "Want to see prices in your local currency?": "هل تريد رؤية الأسعار بعملة بلدك؟",
  "Choose your Gulf country and we will show an estimated local price.": "اختر دولتك الخليجية وسنعرض لك السعر التقديري بعملتك المحلية.",
  "Choose your country": "اختر دولتك",
  "Prices in USD": "الأسعار بالدولار الأمريكي",
  "Local prices are estimates. Your final invoice uses the plan billing currency and current payment rate.": "الأسعار المحلية تقديرية. تستخدم فاتورتك النهائية عملة الباقة وسعر الصرف وقت الدفع.",
  "Pay your subscription to unlock this website": "ادفع اشتراكك لفتح هذا الموقع",
  "This store is not accepting visits or orders until its subscription is activated.": "هذا المتجر لا يستقبل الزيارات أو الطلبات حتى يتم تفعيل اشتراكه.",
  "Pay subscription": "دفع الاشتراك",
  "Your subscription is inactive": "اشتراكك غير نشط",
  "Sales are paused until you pay for your plan. Your cart is saved.": "تم إيقاف المبيعات حتى تدفع قيمة باقتك. ستبقى السلة محفوظة.",
  "Back to POS": "العودة إلى نقطة البيع",
  "Your subscription is inactive. Pay for your plan to accept sales and orders.": "اشتراكك غير نشط. ادفع قيمة باقتك لاستقبال المبيعات والطلبات.",

  // Paying for the plan
  "You chose the {plan} plan": "الباقة التي اخترتها: {plan}",
  "- pay for it to keep your store running.": "- ادفعها ليبقى متجرك يعمل.",
  "Pay for my plan": "ادفع باقتي",
  "Your chosen plan": "باقتك المختارة",
  "Your store runs more services than this plan includes.": "متجرك يشغّل خدمات أكثر مما تتضمنه هذه الباقة.",
  "This plan includes fewer services than your store runs. Remove a service in Settings > Services first.": "هذه الباقة تتضمن خدمات أقل مما يشغّله متجرك. احذف خدمة من الإعدادات > الخدمات أولًا.",

  // Plan text
  "POS, orders and printed bills": "نقاط البيع والطلبات والفواتير المطبوعة",
  "QR codes for tables and flyers": "رموز QR للطاولات والمطبوعات",
  "Card, bank transfer or cash payments": "الدفع بالبطاقة أو التحويل البنكي أو نقدًا",
  "Everything in the previous plan, plus:": "كل ما في الباقة السابقة، بالإضافة إلى:",
  "Plus:": "بالإضافة إلى:",
  "Staff accounts with roles and page access": "حسابات للموظفين مع أدوار وصلاحيات للصفحات",
  "Kitchen screen and new-order alerts": "شاشة المطبخ وتنبيهات الطلبات الجديدة",
  "Inventory and low-stock alerts": "المخزون وتنبيهات نقص المخزون",
  "Menu, online store and bookings together": "المنيو والمتجر الإلكتروني والحجوزات معًا",
  "Custom roles for every team member": "أدوار مخصصة لكل عضو في الفريق",
  "Live website editor": "محرر الموقع المباشر",
  "Add a restaurant / café menu": "أضف منيو مطعم / مقهى",
  "Dine-in, pickup and delivery orders": "طلبات داخل المحل والاستلام والتوصيل",
  "POS for walk-in orders": "نقاط البيع لطلبات الزبائن في المحل",
  "Kitchen screen with order sound": "شاشة المطبخ مع تنبيه صوتي للطلبات",
  "Tables and QR codes": "الطاولات ورموز QR",
  "Printed bills and kitchen tickets": "فواتير مطبوعة وتذاكر المطبخ",
  "Add an online store": "أضف متجرًا إلكترونيًا",
  "Categories and featured products": "تصنيفات ومنتجات مميزة",
  "Delivery prices for every city in the Gulf": "أسعار توصيل لكل مدينة في الخليج",
  "Add bookings & reservations": "أضف الحجوزات والمواعيد",
  "Appointments, hotel rooms or offices": "مواعيد أو غرف فندقية أو مكاتب",
  "All bookings in one list": "كل الحجوزات في قائمة واحدة",
  "We couldn't load the plans. Check your connection and try again.": "تعذر تحميل الباقات. تحقق من اتصالك وحاول مرة أخرى.",
  "Moved to the {plan} plan so you can add this service.": "تم نقلك إلى {plan} لتتمكن من إضافة هذه الخدمة.",
  "Enter your phone number": "أدخل رقم هاتفك",
  "+{n} more": "+{n} أخرى",
  "What's included": "ما الذي تتضمنه",
  "Want more in the same store?": "تريد المزيد في نفس المتجر؟",
  "with the {plan} plan": "مع {plan}",
};
